import { Text, type BoxProps } from '@chakra-ui/react';

interface Props extends BoxProps {}

export default function FauconisText({ children, fontSize = 'lg', ...props }: Props) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Text fontSize={fontSize} {...props}>
      {children}
    </Text>
  );
}
